  document.addEventListener('DOMContentLoaded', function() {
    const variantSelectors = document.querySelectorAll('.product-card__variants');

    variantSelectors.forEach(selector => {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            console.log('Style changed:', mutation.target, mutation.target.style.display);
            console.trace();
          }
        });
      });

      Array.from(selector.options).forEach(option => {
        observer.observe(option, { attributes: true });
      });

      selector.addEventListener('change', function() {
        console.log('Variant changed:', this.value);

        // Ensure all options are visible
        Array.from(this.options).forEach(option => {
          option.style.display = 'block'; // Force display block
        });

        const productCard = this.closest('.product-card');
        const form = productCard.querySelector('product-form form');
        const selectedOption = this.options[this.selectedIndex];
        const variantId = selectedOption.value;
        
        // Update hidden input with selected variant ID
        const hiddenInput = form.querySelector('input[name="id"]');
        hiddenInput.value = variantId;
        
        // Update price display
        const priceElement = productCard.querySelector('[data-product-price]');
        const comparePriceElement = productCard.querySelector('[data-compare-price]');
        
        if (priceElement) {
          priceElement.innerHTML = selectedOption.dataset.price;
        }
        
        if (comparePriceElement) {
          if (selectedOption.dataset.comparePrice && selectedOption.dataset.comparePrice !== '') {
            comparePriceElement.style.display = 'block';
            comparePriceElement.innerHTML = selectedOption.dataset.comparePrice;
          } else {
            comparePriceElement.style.display = 'none';
          }
        }

        // Update add to cart button state
        const submitButton = form.querySelector('[type="submit"]');
        const isAvailable = selectedOption.dataset.available === 'true';
        const buttonText = submitButton.querySelector('.add-to-cart-text');
        
        if (submitButton) {
          submitButton.disabled = !isAvailable;
          buttonText.textContent = isAvailable ? 'Add' : 'Sold Out';
        }

        // Update inventory badge if it exists
        const inventoryBadge = productCard.querySelector('.product-card__inventory-badge');
        if (inventoryBadge) {
          const inventory = parseInt(selectedOption.dataset.inventory);
          if (inventory <= 10 && inventory > 0) {
            inventoryBadge.style.display = 'flex';
            inventoryBadge.querySelector('strong').textContent = inventory;
          } else {
            inventoryBadge.style.display = 'none';
          }
        }
      });
    });

    // Handle quantity selectors
    document.querySelectorAll('.quantity-selector').forEach(selector => {
      const minusButton = selector.querySelector('[data-quantity-minus]');
      const plusButton = selector.querySelector('[data-quantity-plus]');
      const input = selector.querySelector('[data-quantity-input]');

      minusButton.addEventListener('click', () => {
        const currentValue = parseInt(input.value);
        if (currentValue > 1) {
          input.value = currentValue - 1;
        }
      });

      plusButton.addEventListener('click', () => {
        const currentValue = parseInt(input.value);
        input.value = currentValue + 1;
      });

      input.addEventListener('change', () => {
        if (input.value < 1) {
          input.value = 1;
        }
      });
    });
  });

document.addEventListener("DOMContentLoaded", function () {
  // Add new category cards swiper
  const categorySwiper = new Swiper(".category-cards-swiper", {
    slidesPerView: 2.3,
    spaceBetween: 12,
    navigation: {
      nextEl: ".swiperCatNext",
      prevEl: ".swiperCatPrev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        spaceBetween: 12,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 12,
      },
    },
  });

});


document.addEventListener("DOMContentLoaded", function () {
  // Initialize swiper for each bestseller section
  document.querySelectorAll('.bestsellers').forEach(function(section) {
    const sectionId = section.getAttribute('data-section-id');
    
    // Initialize product carousel swiper for this section
    new Swiper(`.product-carousel-swiper-${sectionId}`, {
      slidesPerView: 2.2,
      spaceBetween: 12,
      navigation: {
        nextEl: `.swiperProductNext-${sectionId}, .swiperButtonNext-${sectionId}`,
        prevEl: `.swiperProductPrev-${sectionId}, .swiperButtonPrev-${sectionId}`,
      },
      breakpoints: {
        550: {
          slidesPerView: 2.5,
          spaceBetween: 7,
        },
        768: {
          slidesPerView: 3.5,
          spaceBetween: 7,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 7,
        },
      },
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  // Initialize swiper for each collections-bestsellers section
  document.querySelectorAll('.collections-bestsellers').forEach(function(section) {
    const sectionId = section.getAttribute('data-section-id');
    
    // Initialize product carousel swiper for this section
    new Swiper(`.product-carousel-swiper-${sectionId}`, {
      slidesPerView: 2.2,
      spaceBetween: 12,
      navigation: {
        nextEl: `.swiperButtonNext-${sectionId}`,
        prevEl: `.swiperButtonPrev-${sectionId}`,
      },
      pagination: {
        el: `.swiperPagination-${sectionId}`,
        clickable: true,
      },
      breakpoints: {
        550: {
          slidesPerView: 2.5,
          spaceBetween: 7,
        },
        768: {
          slidesPerView: 3.5,
          spaceBetween: 7,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 7,
        },
      },
    });
  });
});
